import React from 'react'
import {Button, Icon, Modal} from '@therms/atalaya'
import {RPCDocs} from '@therms/react-modules'
import {BsFillPersonFill} from 'react-icons/bs'
import {FaCarSide} from 'react-icons/fa'
import {MdInventory, MdUpload} from 'react-icons/md'

interface NewRecordModalProps {
  bulkImport?: boolean
  closeHandler?: () => void
  onSelectBulkImport?: () => void
  onSelectRecordType: (type: RPCDocs.Records.CreateRecord.v1.Type) => void
}

function NewRecordModal({
  bulkImport,
  closeHandler,
  onSelectBulkImport,
  onSelectRecordType,
}: NewRecordModalProps) {
  return (
    <Modal
      closeHandler={closeHandler}
      escPressClose
      header={
        <span className="flex items-center justify-between">
          <span className="text-neutral text-lg font-bold">
            {bulkImport ? 'Bulk Import Records' : 'New Record Type'}
          </span>

          {!bulkImport && onSelectBulkImport && (
            <span>
              <Button onClick={onSelectBulkImport} subtle>
                <Icon Icon={MdUpload} size="sm" /> Bulk
              </Button>
            </span>
          )}
        </span>
      }
    >
      <div className="gap-x-base my-3 inline-flex w-full justify-evenly">
        <Button
          className="p-5"
          onClick={() =>
            onSelectRecordType(RPCDocs.Records.CreateRecord.v1.Type.Item)
          }
          subtle
          variant="main"
        >
          <div className="gap-y-sm flex flex-col items-center">
            <Icon Icon={MdInventory} size="lg" />
            {!bulkImport ? <div>Item</div> : <div>Bulk Items</div>}
          </div>
        </Button>

        <Button
          className="p-5"
          onClick={() =>
            onSelectRecordType(RPCDocs.Records.CreateRecord.v1.Type.Person)
          }
          subtle
          variant="main"
        >
          <div className="gap-y-sm flex flex-col items-center">
            <Icon Icon={BsFillPersonFill} size="lg" />
            {!bulkImport ? <div>Person</div> : <div>Bulk Persons</div>}
          </div>
        </Button>

        <Button
          className="p-5"
          onClick={() =>
            onSelectRecordType(RPCDocs.Records.CreateRecord.v1.Type.Vehicle)
          }
          subtle
          variant="main"
        >
          <div className="gap-y-sm flex flex-col items-center">
            <Icon Icon={FaCarSide} size="lg" />
            {!bulkImport ? <div>Vehicle</div> : <div>Bulk Vehicles</div>}
          </div>
        </Button>
      </div>
    </Modal>
  )
}

export {NewRecordModal}
